var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-button"},[_c('div',{staticClass:"info-icon",on:{"mouseenter":function($event){_vm.showInfo=true},"mouseleave":function($event){_vm.showInfo=false}}}),(_vm.showInfo)?_c('div',{staticClass:"popup"},[_vm._v(_vm._s(_vm.$t(_vm.infoKey)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }